import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import { packageData } from "@/mixins/index";
import uploadAPK from '@/components/uploadAPK';
import util from '@/libs/util';
import axios from 'axios';
export default {
  mixins: [popUp, packageData],
  components: {
    uploadAPK: uploadAPK
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      reqLoading: false,
      formData: {
        id: "",
        game_group_id: "",
        package_name: "",
        package_desc: "",
        package_version: "",
        status: 1,
        package: "",
        package_path: ''
      },
      chooseStatus: 1,
      formDataParams: null,
      isReWrite: false,
      formDataPrimitive: {},
      formDataMake: {},
      fileList: [],
      rules: {
        game_group_id: [{
          required: true,
          message: "请选择游戏组ID",
          trigger: "blur"
        }],
        package_name: [{
          required: true,
          message: "请输入母包名称",
          trigger: "blur"
        }],
        package_desc: [{
          required: true,
          message: "请输入母包描述",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请输入母包状态",
          trigger: "blur"
        }],
        package: [{
          required: true,
          message: "请输入母包文件",
          trigger: "blur"
        }],
        package_version: [{
          required: true,
          message: "请输入母包版本",
          trigger: "blur"
        }],
        package_path: [{
          required: true,
          message: "请输入文件地址",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.getcommonData(['gameGroupList']);
  },
  methods: {
    init: function init(data, isCopy) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // this.formData = {
                //   id: "",
                //   game_group_id: "",
                //   package_name: "",
                //   package_desc: "",
                //   package_version: "",
                //   status: 1,
                //   package:"",
                //   package_path: ''
                // },
                _this.copyPrimitive();

                _this.chooseStatus = 1;

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  Object.keys(_this.formData).forEach(function (key) {
                    _this.formData[key] = data[key];
                  });
                  _this.formData.package_path = datas.package_path; // this.formData.package_size = datas.package_size;

                  _this.chooseStatus = 2;
                }

                if (isCopy) {
                  _this.formData.id = "";
                }

                _this.copyData();

                _this.isReWrite = true;
                _this.dialogFormVisible = true;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    groupNameChange: function groupNameChange(e) {
      if (e) {
        var data = this.gameGroupList.find(function (i) {
          return i.id == e;
        });
        this.formData.game_group_id = data.id;
      } else {
        this.formData.game_group_id = '';
      }
    },
    statusChange: function statusChange(e) {
      if (e == 2) {
        this.formData.package = "";
        this.fileList = [];
        this.formData.package_path = "";
      }
    },
    handleExceed: function handleExceed() {
      this.$message.error("\u53EA\u80FD\u4E0A\u4F20\u4E00\u4E2A\u6587\u4EF6!");
    },
    handleChange: function handleChange(file, fileList) {
      this.fileList = fileList;
      this.formData.package = fileList.length ? fileList[0].raw : "";
      console.log("fileList==", this.fileList);
      this.submitUpload();
    },
    // 格式化文件大小（带单位）
    formatFileSize: function formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      var units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      var i = Math.floor(Math.log(bytes) / Math.log(1024));
      return "".concat((bytes / Math.pow(1024, i)).toFixed(2), " ").concat(units[i]);
    },
    handleRemove: function handleRemove(file, fileList) {
      // 从fileList中移除当前文件
      this.fileList = this.fileList.filter(function (item) {
        return item.uid !== file.uid;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var isLt10M = file.size / 1024 / 1024 < 1020;

      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 1G!');
      }

      return isLt10M;
    },
    submitUpload: function submitUpload() {
      var _this2 = this;

      if (this.fileList.length === 0) {
        this.$message.warning('请先选择文件');
        return;
      }

      var formData = new FormData();
      this.fileList.forEach(function (file) {
        formData.append('file', file.raw);
      });
      var reqFn = "operation/upload_apk";
      axios.post(process.env.VUE_APP_API + reqFn, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "Authorization": 'Bearer ' + (util.cookies.get('token') || '')
        }
      }).then(function (res) {
        if (res.data.status == 200) {
          _this2.formData.package_path = res.data.data;

          _this2.$message({
            message: '上传成功',
            type: 'success'
          });
        }
      });
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = true;
      this.clearData(isClear);
    },
    clearData: function clearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.isReWrite = false;
      this.formData = JSON.parse(JSON.stringify(isClear ? this.formDataPrimitive : this.formDataMake));
      this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.formDataParams = new FormData();
      Object.keys(this.formData).forEach(function (key) {
        _this3.formDataParams.append(key, _this3.formData[key]);
      });
      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _this3.reqLoading = true;
                    data = JSON.parse(JSON.stringify(_this3.formData)); // if (this.formData.id) {
                    //   await this.secondConfirmation()
                    // }

                    reqFn = data.id ? 'originPkgUpdate' : 'origin-pkg/add'; //  修改

                    if (_this3.formData.id) {
                      _this3.$api[reqFn](data).then(function (res) {
                        if (res.status == 200) {
                          _this3.$message({
                            message: '操作成功',
                            type: 'success'
                          });

                          _this3.dialogFormVisible = false;

                          _this3.$emit('change');
                        }
                      }).finally(function () {
                        _this3.reqLoading = false;
                      });
                    } else {
                      //新增
                      axios.post(process.env.VUE_APP_API + reqFn, _this3.formDataParams, {
                        headers: {
                          'Content-Type': 'multipart/form-data',
                          "Authorization": 'Bearer ' + (util.cookies.get('token') || '')
                        }
                      }).then(function (res) {
                        if (res.status == 200) {
                          _this3.$message({
                            message: '操作成功',
                            type: 'success'
                          });

                          _this3.dialogFormVisible = false;

                          _this3.$emit('change');
                        }
                      }).finally(function () {
                        _this3.reqLoading = false;
                      });
                    }
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};